<template>
<form class="search-form" method="get" @submit.prevent="submit" v-if="action">
    <div class="field has-addons">
        <div class="control">
            <input class="input" v-model="term" type="text" placeholder="person, org, keywords...">
        </div>
        <div class="control">
            <button type="submit" class="button is-primary neat">Search</button>
        </div>
    </div>
</form>
</template>

<script>
export default {
    name    :   'SearchForm',
    props   :   ['action'],
    data()
    {
        return {
            term    :   this.$route.query.term
        }
    },
    methods :   {
        submit(e)
        {
            if (this.term && this.term.trim().length) {
                this.$router.push({path: this.action, query: { term: this.term }});
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/forms/SearchForm.vue